import css from './AvatarStack.module.css'
import Avatar from '../Avatar/Avatar.tsx'

interface AvatarStackMember {
    id: string
    username: string
    color: string
    avatarImage: string | null
}

interface AvatarStackProps {
    members: AvatarStackMember[]
    maxVisible?: number
    onClick?: () => void
}

const AvatarStack = ({ members, maxVisible = 5, onClick }: AvatarStackProps) => {
    const visibleMembers = members.slice(0, maxVisible)
    const remainingCount = members.length - maxVisible

    return (
        <div className={css.stack} onClick={onClick}>
            {visibleMembers.map((member, index) => (
                <div
                    key={member.id}
                    className={css.avatarWrapper}
                    style={{ zIndex: visibleMembers.length + index }}
                >
                    <Avatar
                        title={member.username}
                        color={member.color}
                        avatar={member.avatarImage}
                    />
                </div>
            ))}
            {remainingCount > 0 && (
                <div className={css.moreCount}>+{remainingCount}</div>
            )}
        </div>
    )
}

export default AvatarStack
